import { render, staticRenderFns } from "./Commontag.vue?vue&type=template&id=51ee737e&scoped=true"
import script from "./Commontag.vue?vue&type=script&lang=js"
export * from "./Commontag.vue?vue&type=script&lang=js"
import style0 from "./Commontag.vue?vue&type=style&index=0&id=51ee737e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ee737e",
  null
  
)

export default component.exports